import { commonAPI } from '@redux/api/common.api'
import { URLS } from '@constants'
import { MobileScreen } from '@mobileTypes'

type GETMobileScreensParams = {
  searchPattern?: string
  sort?: string
}

export const mobileScreenApi = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchAllMobileScreens: build.query<MobileScreen[], GETMobileScreensParams | void>({
      query: params => ({
        url: URLS.MOBILE_CFG + '/screen',
        params: {
          searchPattern: params?.searchPattern,
          sort: params?.sort,
        },
      }),
      providesTags: ['AllMobileScreens'],
    }),

    fetchMobileScreenById: build.query<MobileScreen, string>({
      query: id => ({
        url: URLS.MOBILE_CFG + `/screen/id/${id}`,
      }),
      providesTags: ['SingleMobileScreen'],
    }),

    createMobileScreen: build.mutation<MobileScreen, Omit<MobileScreen, 'id' | 'createdAt' | 'updatedAt'>>({
      query: item => ({
        url: URLS.MOBILE_CFG + '/screen',
        method: 'POST',
        body: item,
      }),
      invalidatesTags: ['AllMobileScreens'],
    }),

    updateMobileScreen: build.mutation<MobileScreen, MobileScreen>({
      query: item => ({
        url: URLS.MOBILE_CFG + '/screen',
        method: 'POST',
        body: item,
      }),
      invalidatesTags: ['AllMobileScreens', 'SingleMobileScreen'],
    }),

    deleteMobileScreen: build.mutation<void, string>({
      query: id => ({
        url: URLS.MOBILE_CFG + `/screen/id/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AllMobileScreens'],
    }),

    copyMobileScreen: build.mutation<MobileScreen, { id: string; name: string; internalId: string }>({
      query: body => ({
        url: URLS.MOBILE_CFG + '/screen/copy',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['AllMobileScreens'],
    }),
  }),
})

export const {
  useFetchAllMobileScreensQuery,
  useFetchMobileScreenByIdQuery,
  useCreateMobileScreenMutation,
  useUpdateMobileScreenMutation,
  useDeleteMobileScreenMutation,
  useCopyMobileScreenMutation,
} = mobileScreenApi
